import Swiper from 'swiper';

class BlockSliderEvenements {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.push-evenements__swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      mousewheel: true,
      preventInteractionOnTransition: true,
      breakpoints: {
        350: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }
}

export const blockSliderEvenements = new BlockSliderEvenements();
